// eslint-disable-next-line import/prefer-default-export
export const mccain = [
  {
    caption: 'Authenticate'
  },
  {
    caption: `Select Crop Seasons`
  },
  {
    caption: 'Select Properties'
  },
  {
    caption: 'Review and Submit'
  }
];
